module.exports = [{
      plugin: require('/opt/build/repo/packages/marketing/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-138323558-1","head":false,"anonymize":true,"respectDNT":true},
    }]
